import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import {
  IDocumentImportUploadResult,
  IDocumentImportValidationResult,
} from '@aksia/models';
import { CedricApiService } from '../../infrastructure/api/cedric.api.service';

@Injectable({
  providedIn: 'root',
})
export class DocumentImportService {
  private readonly documentImportUrl = 'DocumentImport';
  private api = inject(CedricApiService);

  validateWorkbook(
    file: File,
  ): Observable<{ results: IDocumentImportValidationResult[] }> {
    const url = this.documentImportUrl + '/ValidateWorkbook';
    const formData = new FormData();
    formData.append('file', file, file.name);
    const additionalParamsMap = new Map<string, any>();
    additionalParamsMap.set('IsFile', true);
    return this.api.post(url, formData, additionalParamsMap);
  }

  uploadFile(
    formData: FormData,
  ): Observable<{ result: IDocumentImportUploadResult }> {
    const url = this.documentImportUrl + '/UploadFile';
    const additionalParamsMap = new Map<string, any>();
    additionalParamsMap.set('IsFile', true);
    return this.api.post(url, formData, additionalParamsMap);
  }
}
